import { useEffect, useState } from "react";
import "../../css/FormularioActor.css";
import { NMTipoDocumento } from "../../shared/Denominaciones";
import axios from "axios";
import { HEADERS_API } from "../NuevaGuia";
import { ListaDepartamentos, ListaDistritos, ListaProvincias } from "../../shared/Ubigeo";

export default function FormularioDirecciones({funcionAgregar, funcionCancelar}){

    //#region HOOKS STATE
    //==========================================================================================
    const[direccion, setDireccion] = useState("");
    const[ubigeo, setUbigeo] = useState("010101");
    const[dpto, setDpto] = useState("01");
    const[prov, setProv] = useState("01");
    const[dist, setDist] = useState("01");
    const[listaDirecciones, setListaDirecciones] = useState(<></>);

    //#endregion

    //#region HOOKS EFFECT
    //==========================================================================================
    useEffect(()=>{
        ObtenerListaDirecciones('f');
    }, []);
    //#endregion

    //#region HANDLERS
    //===========================================================================================
    const HandlerDireccion = (direccion) => setDireccion(direccion.toUpperCase());
    const HandlerUbigeo = (codigo) => setUbigeo(codigo);
    const HandlerDpto = (codigo) => setDpto(codigo);
    const HandlerProv = (codigo) => setProv(codigo);
    const HandlerDist = (codigo) => setDist(codigo);
    const HandlerListaDirecciones = (valor) => setListaDirecciones(valor);
    
    //#endregion

    //#region FUNCIONES
    //==========================================================================================

    // FUNCIONES ASÍNCRONAS
    const ObtenerListaDirecciones = async (tipo) => {
        const paramTipo = tipo == 'a' ? 'anexo' : 'frecuente';
        try{
            const response = await axios.get(URL_LISTAR_DIRECCIONES,{
                headers: HEADERS_API,
                params:{
                    tipoDireccion: paramTipo
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerListaDirecciones(response.data.lista);
        }catch(error){
            console.log(error);
        }
    }

    // Ejecutar función recibida como parámetro
    const ejecutarFuncion = async (direccion, ubigeo) => {
        funcionAgregar(direccion, ubigeo);
        funcionCancelar();
    }
    //#endregion

    //#region CONTENIDO
    //==========================================================================================
    return(<>
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                DIRECCIONES FRECUENTES
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="col-12 py-2 d-flex justify-content-between">
                        <div className="p-2">
                            <button onClick={e=>ObtenerListaDirecciones('f')} className="btn btn-primary">Direcciones frecuentes</button>
                        </div>
                        <div className="p-2">
                            <button onClick={e=>ObtenerListaDirecciones('a')} className="btn btn-primary">Establecimientos anexos</button>
                        </div>
                    </div>
                    <div className="p-1 list-group">
                        {
                            listaDirecciones.length > 0 ? listaDirecciones.map((item, index) => (
                                <div key={index} onClick={e => ejecutarFuncion(item.direccion, item.ubigeo)} className="list-group-item list-group-item-action">{item.direccion} - {item.ubigeo}</div>
                            )) : (
                                <div className="list-group-item">No hay direcciones registradas</div>
                            )
                        }
                    </div>
                    <div className="p-2 d-flex justify-content-center">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>);
    //#endregion
}

//#region CONSTANTES
//==========================================================================================
const URL_LISTAR_DIRECCIONES = process.env.REACT_APP_URL_LISTAR_DIRECCIONES;
//#endregion
